import {toLower, startCase, toString, trim} from 'lodash'
export const paymentLinkedMessage =
  'The address is mapped to an existing payment method on file.'

export const paymentLinkedMessageDelete =
  'Cannot delete because the address is mapped to an existing payment method on file'

export const countryName = {
  CA: 'Canada',
  US: 'United States',
}
export const Phone = (phoneNumber: any): string => {
  const cleaned = toString(phoneNumber).replace(/\D/g, '')
  if (cleaned.length !== 10) {
    return cleaned
  }
  const formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  return formatted
}

export const Name = (name: string): string => {
  return startCase(name)
}

export const Email = (email: string): string => {
  return toLower(trim(email))
}
